import React, { useRef, useState, useEffect } from "react";
import OdrApi from "Service/Odr.api";
import { toast } from "react-toastify";
import {
  initializeChatHub,
  joinChatRoom,
  sendMessage,
  onReceiveMessage,
  leaveChatRoom,
  onReceiveSOS,
  sendSOSAlert,
  markAsRead,
  onReceiveReadReceipt,
  offReceiveReadReceipt,
  onReceiveCallInvite,
  offReceiveCallInvite,
  onReceiveCallEnded,
  offReceiveCallEnded,
} from "../../../../../Service/signalRService";
import { useNotifications } from "Components/Notification/NotificationContext";
import {
  Box,
  Avatar,
  Typography,
  IconButton,
  InputBase,
  Paper,
  Button,
  Modal,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  DialogActions,
  alpha,
  Stack,
  CircularProgress,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Skeleton,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import {
  MoreVert,
  AttachFile,
  Mic,
  Send,
  DeleteForeverRounded,
  CurrencyRupee,
  Campaign,
  Call,
  Videocam,
  Draw as DrawIcon,
  Receipt as ReceiptIcon,
  CheckCircle,
  Close
} from "@mui/icons-material";
import { CaseListType } from "DataTypes/Case.type";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { SingleMessageType } from "DataTypes/Chat.type";
import ImgPath from "Constants/Imgs";
import ChatApi from "Service/Chat.api";
import notificationApi from "Service/Notification.api";
import AdminApi from "Service/Admin.api";
import { msgFormatter } from "./Formatter";
import NoData from "Components/NoData";
import dayjs from "dayjs";
import { parseISTDate } from "Utils/Common";
import AudioComponent from "./AudioComponent";
import AttachmentComponent from "./AttachmentComponent";
import { MeetingApi } from "Service/Meeting.api";
import CaseApi from "Service/Case.api";
import { useDispatch } from "react-redux";
import {
  setAlertData,
  startLoading,
  stopLoading,
} from "../../../../../Redux/Screen/Action";
import { FormDataType } from "DataTypes/Form";
import { MeetingCreationFormArr } from "./Data";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { HandleFormChange, MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB, ValidateFormData, formatUserType } from "Utils/Common";
import StatusUpdateModal from "Components/StatusUpdateModal";
import OdrStatusUpdateModal from "Components/StatusUpdateModal/OdrStatusUpdateModal";
import StatusApi from "Service/Status.api";
import ReportIcon from "@mui/icons-material/Report";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaymentApi from "Service/Payment.api";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useSearchParams } from "react-router-dom";
import AgoraCall from "Components/Conference/AgoraCall";
export interface SingleChatPropType {
  selectedCase: CaseListType | null;
}

// Outside the component or as a ref to prevent re-creation
const sosSound = new Audio("/Assets/audio/siren.mp3");
const ringtoneSound = new Audio("/Assets/audio/skype_call.mp3"); // Using skype call tone as requested

const SingleChatScreen1 = (props: SingleChatPropType) => {
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const dispatch = useDispatch();
  const { selectedCase } = props;
  const [input, setInput] = useState("");
  const [openModal, setOpenMoadal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [openOdrStatusModal, setOpenOdrStatusModal] = useState(false);
  const [messages, setMessages] = useState<SingleMessageType[]>([]);
  const [isLoadingMessages, setIsLoadingMessages] = useState<boolean>(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") as any;
  const initialTab = tabParam && ["joint", "claimant_caucus", "respondent_caucus"].includes(tabParam) ? tabParam : "joint";
  const [activeTab, setActiveTab] = useState<"joint" | "claimant_caucus" | "respondent_caucus">(initialTab);
  const [tabUnreadCounts, setTabUnreadCounts] = useState<{
    joint: number;
    claimant_caucus: number;
    respondent_caucus: number;
  }>({ joint: 0, claimant_caucus: 0, respondent_caucus: 0 });

  const activeTabRef = useRef(activeTab);
  useEffect(() => {
    activeTabRef.current = activeTab;
    setTabUnreadCounts((prev) => ({ ...prev, [activeTab]: 0 }));
  }, [activeTab]);

  useEffect(() => {
    if (tabParam && ["joint", "claimant_caucus", "respondent_caucus"].includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [tabParam]);

  const [hasAccess, setHasAccess] = useState<boolean | null>(null);
  const [accessMessage, setAccessMessage] = useState<string>("");
  const [fullCaseData, setFullCaseData] = useState<any>(null);

  useEffect(() => {
    if (selectedCase?.caseId) {
      setIsLoadingMessages(true);
      setMessages([]);
      setHasAccess(null);
    }
  }, [selectedCase?.caseId]);

  const isMediation = selectedCase?.orderType?.toLowerCase().includes("mediation");
  const isClaimant = selectedCase?.clientId === myInfo?.id;
  const isRespondent = !isClaimant && (myInfo?.userType === "USER" || myInfo?.userType === "CORPORATEUSER" || myInfo?.userType === "NRIUSER");
  const isNeutral = myInfo?.userType === "PROFESSIONAL";
  const isAdmin = myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN";
  const isOdrCase =
    selectedCase?.orderType?.toLowerCase().includes("mediation") ||
    selectedCase?.orderType?.toLowerCase().includes("arbitration") ||
    selectedCase?.orderType?.toLowerCase().includes("negotiation");

  const [odrStatusInput, setOdrStatusInput] = useState("");
  const [odrStatusSubmitting, setOdrStatusSubmitting] = useState(false);

  const filteredMessages = (messages || []).filter((msg) => {
    if (!isMediation) return true;
    const type = msg.messageType || "";
    if (activeTab === "joint") {
      return !type.endsWith(":claimant_caucus") && !type.endsWith(":respondent_caucus");
    }
    if (activeTab === "claimant_caucus") {
      return type.endsWith(":claimant_caucus");
    }
    if (activeTab === "respondent_caucus") {
      return type.endsWith(":respondent_caucus");
    }
    return true;
  });
  const [formData, setFormData] = useState<FormDataType[]>([]);
  const [selectedDocument, setSelectedDocument] = useState<{
    url: string | null;
    docType: "video" | "image" | null;
  }>({
    url: null,
    docType: null,
  });
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [recordingChunks, setRecordingChunks] = useState<Blob[]>([]);
  const [recordedAudioUrl, setRecordedAudioUrl] = useState<string | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  const [eSignModalOpen, setESignModalOpen] = useState(false);
  const [eStampModalOpen, setEStampModalOpen] = useState(false);
  const [eSignFile, setESignFile] = useState<File | null>(null);
  const [eStampFile, setEStampFile] = useState<File | null>(null);
  const [eStampState, setEStampState] = useState("");
  const [stampStates, setStampStates] = useState<any[]>([]);
  const [actionLoading, setActionLoading] = useState(false);
  const [agoraCallData, setAgoraCallData] = useState<{
    open: boolean;
    appId: string;
    channelName: string;
    token: string;
    uid: number;
    messageId?: number;
    participants: any[];
    isVideoCall?: boolean;
  }>({
    open: false,
    appId: "",
    channelName: "",
    token: "",
    uid: 0,
    participants: [],
    isVideoCall: false,
  });
  const [analyserNode, setAnalyserNode] = useState<AnalyserNode | null>(null);
  const caseId = selectedCase?.caseId;

  // --- Sync Read Status ---
  useEffect(() => {
    if (caseId && hasAccess === true) {
      console.log("caseId", caseId);
      // 1. Mark as Read in Backend (Notifications)
      notificationApi.markCaseNotificationsAsRead(Number(caseId))
        .catch((error: any) => {
          console.error("Failed to mark notifications as read", error);
        });

      // 1.1 Mark Messages as Read (Chat Flags)
      ChatApi.markMessagesAsRead({ caseId: Number(caseId) })
        .catch((error: any) => {
          console.error("Failed to mark messages as read", error);
        });

      // 2. Update LocalStorage (for Topbar Badge)
      const saved = localStorage.getItem("unread_notifications");
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          // Filter out notifications for the current case
          const updated = parsed.filter((n: any) => Number(n.caseId) !== Number(caseId));
          localStorage.setItem("unread_notifications", JSON.stringify(updated));

          // 3. Trigger UI Update
          window.dispatchEvent(new Event("notificationsUpdated"));
        } catch (e) {
          console.error("Error updating local notifications", e);
        }
      }
    }
  }, [caseId, hasAccess]);
  const senderUserId = myInfo?.id;
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [caseStatus, setCaseStatus] = useState<any[]>([])
  const scrollRef = React.useRef<HTMLDivElement | null>(null);
  // 1. Add these states at the top of your component
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [baseAmount, setBaseAmount] = useState("");
  const [isGeneratingLink, setIsGeneratingLink] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    if (selectedCase?.currentProcessingStatusName) {
      StatusApi.getFinalStatuses().then((res: any) => {
        const finalStatuses = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
        const normalized = finalStatuses.map((s: string) => s.trim().toLowerCase());
        if (normalized.includes(selectedCase.currentProcessingStatusName.trim().toLowerCase())) {
          setIsCompleted(true);
        } else {
          setIsCompleted(false);
        }
      }).catch(() => setIsCompleted(false));
    }
  }, [selectedCase?.currentProcessingStatusName]);

  const { setActiveCaseId, markCaseNotificationsAsRead } = useNotifications();

  // Synchronize active case with NotificationContext to auto-read incoming messages
  useEffect(() => {
    if (caseId && setActiveCaseId) {
      const numericCaseId = Number(caseId);
      setActiveCaseId(numericCaseId);

      // Also mark existing ones as read immediately
      if (markCaseNotificationsAsRead) {
        markCaseNotificationsAsRead(numericCaseId);
      }
    }
    return () => {
      if (setActiveCaseId) setActiveCaseId(null);
    };
  }, [caseId, setActiveCaseId, markCaseNotificationsAsRead]);

  useEffect(() => {
    if (caseId) {
      CaseApi.fetchCaseById({ caseId: Number(caseId) }).then((res: any) => {
        if (res?.success && res?.data) {
          const caseData = res.data;
          setFullCaseData(caseData);
          const isOdr = ["Online Mediation", "Online Arbitration", "Arbitration", "Online Negotiation"].includes(caseData.orderTypeName);

          const isClaimantUser = caseData.clientId === myInfo?.id;
          const isNeutralUser = myInfo?.userType === "PROFESSIONAL";
          const isAdminUser = myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN";
          const isRespondentUser = 
            (myInfo?.email && caseData.respondentEmail && myInfo.email.trim().toLowerCase() === caseData.respondentEmail.trim().toLowerCase()) ||
            (myInfo?.phone && caseData.respondentPhone && myInfo.phone.trim().replace(/\D/g, '').endsWith(caseData.respondentPhone.trim().replace(/\D/g, ''))) ||
            (!isClaimantUser && !isNeutralUser && !isAdminUser);

          const respondentConsentUpper = (caseData.respondentConsentStatus || "").trim().toUpperCase();
          if (isOdr && isRespondentUser && respondentConsentUpper !== "ACCEPTED" && respondentConsentUpper !== "GIVEN" && respondentConsentUpper !== "CONFIRMED") {
            setHasAccess(false);
            if (caseData.respondentConsentStatus === "Rejected" || caseData.respondentConsentStatus === "Declined") {
              setAccessMessage("Access Restricted: You have rejected the case invitation.");
            } else {
              setAccessMessage("Access Restricted: You must accept the case consent before entering the chat room.");
            }
            return;
          }

          if (isOdr && myInfo?.userType === "PROFESSIONAL") {
            const matchedProf = caseData.assignedProfessionals?.find((p: any) => Number(p.professionalId) === Number(myInfo?.id));
            const isNeutralUser = Number(caseData.assignedProfessionalId) === Number(myInfo?.id);

            if (matchedProf) {
              if (matchedProf.consentStatus !== "Confirmed" && matchedProf.consentStatus !== "Accepted" && matchedProf.consentStatus !== "GIVEN") {
                setHasAccess(false);
                if (matchedProf.consentStatus === "Rejected" || matchedProf.consentStatus === "Declined") {
                  setAccessMessage("Access Restricted: You have rejected the case assignment.");
                } else {
                  setAccessMessage("Access Restricted: You must accept the case assignment and provide a conflict disclosure before entering the chat room.");
                }
                return;
              }
            } else if (isNeutralUser) {
              if (caseData.neutralConsentStatus !== "Confirmed" && caseData.neutralConsentStatus !== "Accepted" && caseData.neutralConsentStatus !== "GIVEN") {
                setHasAccess(false);
                if (caseData.neutralConsentStatus === "Rejected" || caseData.neutralConsentStatus === "Declined") {
                  setAccessMessage("Access Restricted: You have rejected the case assignment.");
                } else {
                  setAccessMessage("Access Restricted: You must accept the case assignment and provide a conflict disclosure before entering the chat room.");
                }
                return;
              }
            }
          }
          setHasAccess(true);
        }
      }).catch(() => setHasAccess(true));
    }
  }, [caseId, myInfo]);

  // Inside SingleChatScreen1 component



  useEffect(() => {
    if (!caseId || !senderUserId || hasAccess !== true) return;
    const token = localStorage.getItem("token") || "";

    if (caseId) {
      // 1. Get existing notifications from localStorage
      const saved = localStorage.getItem("unread_notifications");
      if (saved) {
        const notifications = JSON.parse(saved);

        // 2. Filter out any notifications matching the current caseId
        const filtered = notifications.filter((n: any) => n.caseId !== Number(caseId));

        // 3. Save back to localStorage
        localStorage.setItem("unread_notifications", JSON.stringify(filtered));

        // 4. Dispatch a custom event to tell the Topbar to refresh its state
        window.dispatchEvent(new Event("notificationsUpdated"));
      }
    }

    // 1. Initialize/Ensure connection is active
    initializeChatHub(token).then(() => {
      // 2. Join the specific case room
      joinChatRoom(caseId.toString());

      // Mark messages & notifications as read immediately upon entering room
      markAsRead(Number(caseId), Number(senderUserId));
      if (markCaseNotificationsAsRead) {
        markCaseNotificationsAsRead(Number(caseId));
      }

      // 3. Listen for regular messages
      onReceiveMessage((message) => {
        const incomingCaseId = message?.caseId ?? message?.CaseId;
        if (incomingCaseId && Number(incomingCaseId) !== Number(caseId)) return;

        const formattedMsg = msgFormatter(message);

        setMessages((prev: any) => {
          // Deduplicate based on PkChatMessage
          const exists = prev.some((m: any) =>
            m.pkChatMessage && Number(m.pkChatMessage) === Number(formattedMsg.pkChatMessage)
          );
          if (exists) return prev;
          return [...prev, formattedMsg];
        });

        // Increment tab unread count if not the active tab and not sent by me
        const mType = (message?.messageType ?? message?.MessageType ?? "").trim().toLowerCase();
        let msgTab: "joint" | "claimant_caucus" | "respondent_caucus" = "joint";
        if (mType.endsWith(":claimant_caucus")) msgTab = "claimant_caucus";
        else if (mType.endsWith(":respondent_caucus")) msgTab = "respondent_caucus";

        const senderId = message?.senderUserId ?? message?.SenderUserId;
        if (senderId && myInfo?.id && Number(senderId) !== Number(myInfo.id)) {
          if (msgTab !== activeTabRef.current) {
            setTabUnreadCounts(prev => ({
              ...prev,
              [msgTab]: prev[msgTab] + 1
            }));
          }
        }

        // --- NEW: Clear notifications immediately for this case since chat is open ---
        const saved = localStorage.getItem("unread_notifications");
        if (saved) {
          const notifications = JSON.parse(saved);
          const filtered = notifications.filter((n: any) => Number(n.caseId) !== Number(caseId));
          localStorage.setItem("unread_notifications", JSON.stringify(filtered));
          window.dispatchEvent(new Event("notificationsUpdated"));
        }

        // --- NEW: Mark as Read immediately if we are looking at the screen ---
        // (Optional: Check document.hasFocus() or similar if needed)
        markAsRead(Number(caseId), Number(senderUserId));
      });

      // 4. Listen for Read Receipts (Real-time update of checks)
      onReceiveReadReceipt((data) => {
        if (Number(data.CaseId) === Number(caseId)) {
          setMessages((prevMessages) => {
            return prevMessages.map(msg => {
              // Update flags if they aren't already true
              const updated = { ...msg };
              if (data.IsUserRead) updated.isUserRead = true;
              if (data.IsProfessionalRead) updated.isProfessionalRead = true;
              if (data.IsAdminRead) updated.isAdminRead = true;
              if (data.IsCorporateRead) updated.isCorporateRead = true;
              return updated;
            });
          });
        }
      });

      // 4. Listen for SOS specifically within this room (optional, 
      // since Topbar also handles the global alert)
      // onReceiveSOS((data) => {
      //   const sosSystemMsg = {
      //     messageContent: "🚨 SOS: Admin assistance has been requested.",
      //     senderUserId: 0,
      //     messageType: "text",
      //     timestamp: new Date().toISOString(),
      //     link: `/chat/`
      //   };
      //   setMessages((prev) => [...prev, msgFormatter(sosSystemMsg)]);
      // });

      // 5. Listen for incoming calls
      onReceiveCallInvite((data) => {
        const initiator = data.initiatedBy || data.InitiatedBy;
        const isVideoCall = data.isVideoCall || data.IsVideoCall;

        // Play Ringtone
        ringtoneSound.play().catch(e => console.warn("Audio play failed:", e));

        dispatch(
          setAlertData({
            alertMessage: `Incoming ${isVideoCall ? "Video " : ""}Call from ${initiator}`,
            alertVariant: "info",
            openAlert: true,
          })
        );
      });

      // 6. Listen for Call Ended event
      onReceiveCallEnded((data) => {
        const mid = data.messageId || data.MessageId;
        const dur = data.duration || data.Duration;

        setMessages((prev) =>
          prev.map((msg) => {
            if (Number(msg.pkChatMessage) === Number(mid)) {
              return {
                ...msg,
                isCallEnded: true,
                callDuration: dur,
                messageContent: `📞 Call ended. Duration: ${dur}`
              };
            }
            return msg;
          })
        );

        // Auto-close modal if this specific call ended
        setAgoraCallData(prev => {
          if (prev.open && Number(prev.messageId) === Number(mid)) {
            return { ...prev, open: false };
          }
          return prev;
        });
      });
    });

    handleFetchChatHistory();
    handleInitialLoad();

    return () => {
      leaveChatRoom(caseId.toString());
      offReceiveReadReceipt();
      offReceiveCallInvite();
      offReceiveCallEnded();
    };
  }, [caseId, senderUserId, hasAccess]);

  // 2. ADD THIS EFFECT TO SCROLL TO BOTTOM ON LOAD AND WHEN MESSAGES CHANGE
  React.useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [filteredMessages, activeTab]); // Runs every time messages array or tab updates

  const handleSOSRequest = async () => {
    if (!caseId || !senderUserId) return;
    try {
      await sendSOSAlert(caseId.toString(), senderUserId);
      dispatch(setAlertData({
        alertMessage: "SOS Sent! Admins have been notified.",
        alertVariant: "success",
        openAlert: true,
      }));
    } catch (err) {
      console.error("SOS failed", err);
    }
  };

  const handleDeleteChat = async () => {
    if (!caseId) return;
    if (!window.confirm("Are you sure you want to delete this case? This action cannot be undone.")) {
      return;
    }

    try {
      dispatch(startLoading({ loading: true, loadtext: "Deleting case..." }));
      const res = await AdminApi.deleteCase(Number(caseId));
      if (res && res.success) {
        dispatch(setAlertData({
          alertMessage: "Case deleted successfully!",
          alertVariant: "success",
          openAlert: true,
        }));
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        dispatch(setAlertData({
          alertMessage: res?.message || "Failed to delete case.",
          alertVariant: "error",
          openAlert: true,
        }));
      }
    } catch (error: any) {
      console.error("Error deleting case:", error);
      dispatch(setAlertData({
        alertMessage: error.response?.data || "An error occurred while deleting case.",
        alertVariant: "error",
        openAlert: true,
      }));
    } finally {
      dispatch(stopLoading());
    }
  };

  const handleInitialLoad = async () => {
    const newArr: FormDataType[] = JSON.parse(
      JSON.stringify(MeetingCreationFormArr)
    );
    newArr[0].value =
      newArr[4].value = ` Meeting for ${selectedCase?.orderType} - ${selectedCase?.caseId} - ${selectedCase?.caseType}`; // Default topic and agenda
    newArr[3].value = "30"; // Default duration
    setFormData(newArr);
  };

  useEffect(() => {
    if (!analyserNode || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const bufferLength = analyserNode.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    const draw = () => {
      if (!isRecording) return;

      analyserNode.getByteTimeDomainData(dataArray);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.beginPath();

      for (let i = 0; i < bufferLength; i++) {
        const x = (i / bufferLength) * canvas.width;
        const y = (dataArray[i] / 128.0) * (canvas.height / 2);
        ctx.lineTo(x, y);
      }

      ctx.strokeStyle = "red";
      ctx.stroke();
      requestAnimationFrame(draw);
    };

    draw();
  }, [analyserNode, isRecording]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape")
        setSelectedDocument({
          docType: null,
          url: null,
        });
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleFetchChatHistory: () => void = async () => {
    setIsLoadingMessages(true);
    try {
      const res = await ChatApi.fetchChatHistoryByCaseId({ caseId: caseId });
      if (res?.success) {
        let formatteRes: SingleMessageType[] = res?.data?.map((el: any) => {
          return msgFormatter(el);
        });
        if (myInfo.userType === "ADMIN") {
          formatteRes = formatteRes.filter(
            (el) => el.messageType !== "file" && el.messageType !== "audio"
          );
        }

        // Compute unread counts per tab
        const counts = { joint: 0, claimant_caucus: 0, respondent_caucus: 0 };
        if (Array.isArray(res.data)) {
          res.data.forEach((el: any) => {
            const senderId = el.senderUserId ?? el.SenderUserId;
            if (senderId && myInfo?.id && Number(senderId) === Number(myInfo.id)) return;

            let isUnread = false;
            const uType = myInfo?.userType;
            if (isClaimant) {
              isUnread = uType === "CORPORATEUSER" ? !(el.isCorporateRead ?? el.IsCorporateRead) : !(el.isUserRead ?? el.IsUserRead);
            } else if (isRespondent) {
              isUnread = !(el.isRespondentRead ?? el.IsRespondentRead);
            } else if (isNeutral) {
              isUnread = !(el.isProfessionalRead ?? el.IsProfessionalRead);
            } else if (isAdmin) {
              isUnread = !(el.isAdminRead ?? el.IsAdminRead);
            }

            if (isUnread) {
              const mType = (el.messageType ?? el.MessageType ?? "").trim().toLowerCase();
              let msgTab: "joint" | "claimant_caucus" | "respondent_caucus" = "joint";
              if (mType.endsWith(":claimant_caucus")) msgTab = "claimant_caucus";
              else if (mType.endsWith(":respondent_caucus")) msgTab = "respondent_caucus";

              if (msgTab !== activeTabRef.current) {
                counts[msgTab]++;
              }
            }
          });
        }
        setTabUnreadCounts(counts);

        if (res?.data?.[0]?.caseTypeId) {
          const status = await StatusApi.caseStatus(res?.data?.[0]?.caseTypeId);
          setCaseStatus(status?.data);
        }
        setMessages(formatteRes);
      }
    } catch (err) {
      console.error("Failed to fetch chat history", err);
    } finally {
      setIsLoadingMessages(false);
    }
  };

  const handleSend = async () => {
    if (!caseId || !senderUserId) return;

    // If there's a recorded audio ready to be sent
    if (recordedAudioUrl && recordingChunks.length) {
      const blob = new Blob(recordingChunks, { type: "audio/webm" });
      const res = await ChatApi.handleUploadVoice({
        audioBlob: blob,
        caseId,
        senderUserId,
      });

      if (res?.success && res?.data?.url) {
        const typeSuffix = activeTab === "claimant_caucus" ? ":claimant_caucus" : activeTab === "respondent_caucus" ? ":respondent_caucus" : "";
        await sendMessage(
          caseId,
          senderUserId,
          "",
          "audio" + typeSuffix,
          `${process.env.REACT_APP_BASE_URL}${res.data.url}`,
          res?.data?.fileName || "voiceMessage.webm"
        );
      }

      // Cleanup after sending audio
      handleDeleteRecording();
      return;
    }

    // Otherwise, send text message
    if (input.trim()) {
      const typeSuffix = activeTab === "claimant_caucus" ? ":claimant_caucus" : activeTab === "respondent_caucus" ? ":respondent_caucus" : "";
      await sendMessage(caseId, senderUserId, input.trim(), "text" + typeSuffix, "", "");
      setInput("");
    }
  };

  const handleEnterPress: (event: any) => void = (event) => {
    if (event?.keyCode === 13 || event?.key === "Enter") {
      if (event.shiftKey) {
        // Shift+Enter: let the default behaviour add a newline
        return;
      }
      event.preventDefault();
      handleSend();
    }
  };

  const handleStartRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const chunks: Blob[] = [];
      setRecordingChunks([]);
      setRecordedAudioUrl(null);
      setMediaRecorder(recorder);
      setIsRecording(true);

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.push(e.data);
      };

      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);
        setRecordingChunks(chunks);
        setRecordedAudioUrl(url);
        setIsRecording(false);
      };

      // Setup AnalyserNode for waveform
      const audioContext = new AudioContext();
      const source = audioContext.createMediaStreamSource(stream);
      const analyser = audioContext.createAnalyser();
      source.connect(analyser);
      setAnalyserNode(analyser);

      recorder.start();
    } catch (error) {
      console.error("Recording failed", error);
    }
  };

  const handleStopRecording = () => {
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const handleDeleteRecording = () => {
    setRecordedAudioUrl(null);
    setRecordingChunks([]);
    setMediaRecorder(null);
  };

  const handleAttachmentUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    //show loader or disable input while uploading
    dispatch(startLoading({ loading: true, loadtext: "Uploading..." }));

    const files = event.target.files;
    if (!files || !caseId || !senderUserId) return;

    const fileArray = Array.from(files);

    try {
      const BLOCKED_EXTENSIONS = [".exe", ".apk", ".bat", ".cmd", ".sh", ".php", ".js", ".vbs", ".ps1", ".msi", ".dll", ".scr", ".jar", ".html", ".htm", ".pif", ".com", ".iso", ".zip"];
      const ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".heic", ".heif", ".webp", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".txt", ".csv", ".mp4", ".webm", ".mov", ".mp3", ".wav", ".m4a"];

      const invalidFiles = fileArray.filter((file) => {
        const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
        return BLOCKED_EXTENSIONS.includes(ext) || !ALLOWED_EXTENSIONS.includes(ext);
      });

      if (invalidFiles.length > 0) {
        const names = invalidFiles.map((f) => f.name).join(", ");
        dispatch(
          setAlertData({
            alertMessage: `Invalid file format for: ${names}. Executable files (.exe, .apk, etc.) are strictly prohibited.`,
            alertVariant: "error",
            openAlert: true,
          })
        );
        return;
      }

      const oversizedFiles = fileArray.filter(f => f.size > MAX_FILE_SIZE_BYTES);

      if (oversizedFiles.length > 0) {
        const names = oversizedFiles.map(f => f.name).join(", ");

        dispatch(
          setAlertData({
            alertMessage: `The following files are too large: ${names}. The maximum size is ${MAX_FILE_SIZE_MB}MB.`,
            alertVariant: "error",
            openAlert: true,
          })
        );
        return;
      }

      // 2. Process Uploads
      const uploadPromises = fileArray.map(async (file) => {
        const res = await ChatApi.uploadAttachment({
          attachmentBlob: file,
          caseId: caseId,
        });

        if (res?.success && res?.data?.url) {
          const typeSuffix = activeTab === "claimant_caucus" ? ":claimant_caucus" : activeTab === "respondent_caucus" ? ":respondent_caucus" : "";
          await sendMessage(
            caseId,
            senderUserId,
            "",
            "file" + typeSuffix,
            `${process.env.REACT_APP_BASE_URL}${res.data.url}`,
            res?.data?.fileName
          );
        }
      });

      await Promise.all(uploadPromises);
    } catch (err) {
      console.error("One or more attachment uploads failed", err);
    } finally {
      dispatch(stopLoading());
      // Clear input so user can select the same files again if needed
      event.target.value = "";
    }
  };

  const downloadImage = async (url: string, fileName: string) => {
    try {
      const response = await fetch(url, {
        mode: "cors",
        cache: "no-cache",
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file.");
      }

      let blob = await response.blob();
      let targetFileName = fileName || "image.jpg";

      if (targetFileName.match(/\.(heic|heif)$/i) || url.match(/\.(heic|heif)$/i) || blob.type.includes("heic") || blob.type.includes("heif")) {
        const heic2any = (await import("heic2any")).default;
        const converted = await heic2any({
          blob,
          toType: "image/jpeg",
          quality: 0.9,
        });
        blob = Array.isArray(converted) ? converted[0] : converted;
        targetFileName = targetFileName.replace(/\.(heic|heif)$/i, ".jpg");
      }

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", targetFileName);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed. Please try again.");
    }
  };


  const handleCloseCase = async () => {
    if (isOdrCase) {
      setOpenOdrStatusModal(true);
    } else {
      setOpenStatusModal(true);
    }
  };

  const handleReOpenCase = async () => { };

  const handleStatusUpdate = async (selectedStatus: any) => {
    try {
      dispatch(startLoading({ loading: true, loadtext: "Updating Status..." }));

      // Here you would call your API to update the case status
      // const res = await CaseApi.updateCaseStatus({
      //   caseId: selectedCase?.caseId,
      //   statusId: selectedStatus.pkProcessingStatus
      // });

      // Send a message to the chat about the status update
      if (selectedCase?.caseId && senderUserId) {
        await sendMessage(
          selectedCase.caseId,
          senderUserId,
          `Case status updated to: ${selectedStatus.statusName}.`,
          "text",
          "",
          ""
        );
      }

      dispatch(
        setAlertData({
          alertMessage: `Case status updated to ${selectedStatus.statusName}`,
          alertVariant: "success",
          openAlert: true,
        })
      );

      dispatch(stopLoading());
    } catch (error) {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Failed to update case status",
          alertVariant: "error",
          openAlert: true,
        })
      );
    }
  };
  const handleCallConnection = async (isJoinOnly: boolean = false, isVideoCall: boolean = false, targetUserIds?: number[]) => {
    dispatch(startLoading({ loading: true, loadtext: isJoinOnly ? "Joining Call..." : "Connecting Call..." }));

    const caucusType = activeTab === "claimant_caucus" ? "claimant_caucus" : activeTab === "respondent_caucus" ? "respondent_caucus" : null;

    const res = await MeetingApi.AgoraConferenceCall({
      caseId: selectedCase?.caseId?.toString(),
      isJoinOnly: isJoinOnly,
      isVideoCall: isVideoCall,
      caucusType: caucusType,
      targetUserIds: targetUserIds
    });
    console.log("res", res);
    if (res?.success) {
      dispatch(stopLoading());
      setAgoraCallData({
        open: true,
        appId: res.appId,
        channelName: res.channelName,
        token: res.token,
        uid: res.uid,
        messageId: res.messageId,
        participants: res.participants || [],
        isVideoCall: isVideoCall,
      });
    } else {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Failed to initiate call.",
          alertVariant: "error",
          openAlert: true,
        })
      );
    }
  };

  const [callModalOpen, setCallModalOpen] = useState(false);
  const [callIsVideo, setCallIsVideo] = useState(false);
  const [selectedCallUserIds, setSelectedCallUserIds] = useState<number[]>([]);
  const [isGroupCall, setIsGroupCall] = useState(false);

  const openCallModal = (isVideo: boolean) => {
    setCallIsVideo(isVideo);
    setIsGroupCall(false);
    setSelectedCallUserIds([]);
    setCallModalOpen(true);
  };

  const getCallParticipantsList = () => {
    const memberMap = new Map<number, string>();

    // 1. Add members from selectedCase
    if (selectedCase) {
      if (selectedCase.clientId && Number(selectedCase.clientId) !== Number(senderUserId)) {
        const cName = selectedCase.clientFullName ? `${selectedCase.clientFullName} (Client)` : "Client";
        memberMap.set(Number(selectedCase.clientId), cName);
      }
      if (selectedCase.assignedProfessionalId && Number(selectedCase.assignedProfessionalId) !== Number(senderUserId)) {
        const pName = selectedCase.assignedProfessionalName ? `${selectedCase.assignedProfessionalName} (Professional)` : "Professional";
        memberMap.set(Number(selectedCase.assignedProfessionalId), pName);
      }
    }

    // 2. Add members from fullCaseData
    if (fullCaseData) {
      if (fullCaseData.clientId && Number(fullCaseData.clientId) !== Number(senderUserId)) {
        const cName = fullCaseData.clientFullName ? `${fullCaseData.clientFullName} (Client)` : "Client";
        memberMap.set(Number(fullCaseData.clientId), cName);
      }
      if (fullCaseData.assignedProfessionalId && Number(fullCaseData.assignedProfessionalId) !== Number(senderUserId)) {
        const pName = fullCaseData.assignedProfessionalName ? `${fullCaseData.assignedProfessionalName} (Professional)` : "Professional";
        memberMap.set(Number(fullCaseData.assignedProfessionalId), pName);
      }
      if (Array.isArray(fullCaseData.assignedProfessionals)) {
        fullCaseData.assignedProfessionals.forEach((p: any) => {
          const pId = Number(p.professionalId || p.userId || p.id);
          if (pId && pId !== Number(senderUserId)) {
            const pName = p.name || p.fullName || p.professionalName || p.userName;
            memberMap.set(pId, pName ? `${pName} (${p.role || "Professional"})` : `Professional (${pId})`);
          }
        });
      }
    }

    // 2.1 For Admin Support chats, ensure Admin/SuperAdmin is represented
    if (selectedCase?.orderTypeId === 53 || selectedCase?.orderType === "Admin Support" || fullCaseData?.orderTypeId === 53) {
      if (selectedCase?.assignedAdminId && Number(selectedCase.assignedAdminId) !== Number(senderUserId)) {
        memberMap.set(Number(selectedCase.assignedAdminId), `${selectedCase.assignedAdminName || "Admin"} (Admin)`);
      } else if (fullCaseData?.assignedAdminId && Number(fullCaseData.assignedAdminId) !== Number(senderUserId)) {
        memberMap.set(Number(fullCaseData.assignedAdminId), `${fullCaseData.assignedAdminName || "Admin"} (Admin)`);
      } else {
        let hasAdmin = false;
        if (Array.isArray(messages)) {
          messages.forEach((m: any) => {
            if (m.senderUser?.userType === "ADMIN" || m.senderUser?.userType === "SUPERADMIN") {
              if (Number(m.senderUserId) !== Number(senderUserId)) {
                memberMap.set(Number(m.senderUserId), `${m.senderName || "Admin"} (${formatUserType(m.senderUser.userType)})`);
                hasAdmin = true;
              }
            }
          });
        }
        if (!hasAdmin && myInfo?.userType !== "ADMIN" && myInfo?.userType !== "SUPERADMIN") {
          memberMap.set(1, "Admin Support (Admin)");
        }
      }
    }

    // 3. Add members from chat messages
    if (Array.isArray(messages)) {
      messages.forEach((m: any) => {
        const uId = Number(m.senderUserId);
        if (uId && uId !== Number(senderUserId)) {
          let name = m.senderName;
          const u = m.senderUser;
          if (u) {
            const fullName = (u.fullName || `${u.firstName || ""} ${u.lastName || ""}`).trim();
            if (fullName) {
              name = `${fullName}${u.userType ? ` (${formatUserType(u.userType)})` : ""}`;
            } else if (u.userName) {
              name = u.userName;
            } else if (u.email) {
              name = u.email;
            }
          }
          if (name && !name.toLowerCase().startsWith("user ")) {
            memberMap.set(uId, name);
          } else if (!memberMap.has(uId)) {
            memberMap.set(uId, name || `Member (${uId})`);
          }
        }
      });
    }

    return Array.from(memberMap.entries());
  };

  const handleStartSelectedCall = () => {
    setCallModalOpen(false);
    const targets = isGroupCall ? undefined : selectedCallUserIds;
    handleCallConnection(false, callIsVideo, targets);
  };

  useEffect(() => {
    const autoJoin = searchParams.get("autoJoinCall");
    const isVideo = searchParams.get("isVideoCall") === "true";
    if (autoJoin === "1" && caseId) {
      setTimeout(() => {
        handleCallConnection(true, isVideo);
      }, 1000);
      
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("autoJoinCall");
      newParams.delete("isVideoCall");
      setSearchParams(newParams, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseId, searchParams]);

  const handleScheduleMeet: () => void = async () => {
    dispatch(startLoading({ loading: true, loadtext: "Scheduling Meeting..." }));
    if (!caseId || !senderUserId) return;

    const validation = ValidateFormData(formData);
    setFormData(validation.formData);
    if (!validation.errorCheck && selectedCase?.caseId) {
      dispatch(
        startLoading({ loading: true, loadtext: "Scheduling Meeting..." })
      );

      const date = formData.find((el) => el.id === "startAt")?.value;
      const time = formData.find((el) => el.id === "startTime")?.value;
      const combinedDateTime = dayjs(
        `${date} ${time}`,
        "YYYY-MM-DD hh:mm A"
      ).format("YYYY-MM-DD hh:mm A");
      const payload: any = {
        caseId: selectedCase?.caseId?.toString(),
        topic: formData.find((el) => el.id === "topic")?.value,
        startAt: combinedDateTime,
        durationInMinutes: formData.find((el) => el.id === "durationInMinutes")
          ?.value,
        agenda: formData.find((el) => el.id === "agenda")?.value,
      };
      const res = await MeetingApi.ScheduleMeeting(payload);
      if (res?.success) {
        await sendMessage(
          selectedCase?.caseId,
          senderUserId ?? 0,
          `Meeting successfully scheduled at ${dayjs(payload.startAt).format(
            "YYYY-MM-DD, hh:mm A"
          )}`,
          "text",
          "",
          ""
        );
        dispatch(
          setAlertData({
            alertMessage: "Meeting scheduled successfully.",
            alertVariant: "success",
            openAlert: true,
          })
        );
        dispatch(stopLoading());
        setOpenMoadal(false);
        handleInitialLoad();
      } else {
        dispatch(stopLoading());
      }
    }
  };

  // 2. Add the submit handler
  const handleSendPaymentLink = async () => {
    if (!amount || isNaN(Number(amount))) return;

    dispatch(startLoading({ loading: true, loadtext: "Generating Payment Link..." }));

    setIsGeneratingLink(true);
    try {
      const response = await PaymentApi.generatePaymentLinkForCase({
        caseId: caseId,
        amount: Number(amount),
      });

      const paymentLink = response.data?.paymentLink || response.data?.PaymentLink;
      const paymentId = response.data?.paymentId || response.data?.PaymentId;

      // We send a specific prefix "💳 PAYMENT_REQUEST|" so the UI knows to render a button
      await sendMessage(
        caseId ?? 0,
        myInfo.id ?? 0,
        `PAYMENT_REQUEST|${amount}|${paymentLink}|${paymentId || ''}`,
        "text"
      );

      setPaymentModalOpen(false);
      setAmount("");
    } catch (error) {
      console.error("Failed to generate payment link", error);
    } finally {
      dispatch(stopLoading());
      setIsGeneratingLink(false);
    }
  };

  const modalBody = (
    <Box
      sx={{
        ...sxMain,
        backgroundColor: "common.white",
        boxShadow: "0px 0px 6px #00000029",
        borderRadius: 1.25,
        width: "50%",
      }}
    >
      {
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            ...sxHead,
            justifyContent: "space-between",
            height: "3rem",
          }}
        >
          <Typography
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              "&>svg": {
                mr: 1,
              },
            }}
          >
            Schedule Meetinng
          </Typography>
          {
            <IconButton onClick={() => setOpenMoadal(false)}>
              <ImgPath.CloseIcon />
            </IconButton>
          }
        </Box>
      }
      <Box
        sx={{
          height: "calc(100% - 6rem)",
          p: 2,
        }}
      >
        <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
          {formData.map((el: FormDataType) => (
            <Grid key={el.id} size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}>
              {commonFormSwitch({
                formObj: el,
                onChange: (data) =>
                  setFormData(HandleFormChange(data, formData)),
              })}
            </Grid>
          ))}
        </Grid>
      </Box>
      {
        <Box
          sx={{
            px: 2,
            mb: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            height: "3rem",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleScheduleMeet()}
          >
            Schedule
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setOpenMoadal(false)}
            sx={{ ml: 1, borderColor: "primary.main", color: "primary.main" }}
          >
            Cancel
          </Button>
        </Box>
      }
    </Box>
  );

  const getInitials: (orderType: string) => string = (orderType) => {
    if (!orderType) return "";
    const words = orderType.split(" ");
    let initials = "";
    for (let i = 0; i < words.length && i < 2; i++) {
      initials += words[i].charAt(0).toUpperCase();
    }
    return initials;
  };

  const handleEndCall = async (duration: string) => {
    if (!agoraCallData.messageId) return;
    try {
      await MeetingApi.EndAgoraConferenceCall({
        messageId: agoraCallData.messageId,
        duration: duration
      });
    } catch (e) {
      console.error("Failed to end call session", e);
    }
  };

  const handleDeclineCall = async (msgId: string, isInitiator: boolean) => {
    if (!msgId) return;
    
    if (isInitiator) {
      try {
        await MeetingApi.EndAgoraConferenceCall({
          messageId: msgId,
          duration: "00:00"
        });
      } catch (e) {
        console.error("Failed to cancel call", e);
      }
    } else {
      // Just decline locally for this user
      ringtoneSound.pause();
      ringtoneSound.currentTime = 0;
    }
  };



  const handleOdrProfessionalStatusUpdate = async () => {
    if (!odrStatusInput.trim() || !selectedCase?.caseId || !senderUserId) return;
    setOdrStatusSubmitting(true);
    try {
      const statusNote = odrStatusInput.trim();

      // Hit the new backend endpoint to store the custom status using OdrApi
      const response = await OdrApi.updateOdrCustomStatus(
        selectedCase.caseId,
        { customStatus: statusNote }
      );

      if (response?.success) {
        await sendMessage(
          selectedCase.caseId,
          senderUserId,
          `[ODR STATUS UPDATE] ${statusNote}`,
          "system",
          "",
          ""
        );
        setOdrStatusInput("");
        window.location.reload();
      }
    } catch (err) {
      console.error("Failed to post ODR status update", err);
    } finally {
      setOdrStatusSubmitting(false);
    }
  };

  const fetchStampStates = async () => {
    try {
      const response = await StatusApi.getStampDetails();
      const data = response?.data;
      if (Array.isArray(data)) {
        setStampStates(data);
      } else if (data && Array.isArray(data.data)) {
        setStampStates(data.data);
      } else {
        setStampStates([]);
      }
    } catch (error) {
      console.error("Failed to fetch estamp states", error);
    }
  };

  useEffect(() => {
    if (eStampModalOpen && stampStates.length === 0) {
      fetchStampStates();
    }
  }, [eStampModalOpen]);

  const handleSendForESign = async () => {
    if (!eSignFile || !caseId) return;
    setActionLoading(true);
    const formData = new FormData();
    formData.append("CaseId", caseId.toString());
    formData.append("FileName", eSignFile.name);
    formData.append("PdfFile", eSignFile);

    try {
      const response = await StatusApi.eSignDocument(formData);
      if (response?.data?.success) {
        toast.success("Document successfully sent for E-Sign!");
        setESignModalOpen(false);
        setESignFile(null);
        await sendMessage(caseId, senderUserId ?? 0, `Document '${eSignFile.name}' was sent for E-Sign.`, "system", "", "");
      } else {
        toast.error(response?.data?.message || "Failed to send document.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending for E-Sign.");
    }
    setActionLoading(false);
  };

  const handleSendForEStamp = async () => {
    if (!eStampFile || !caseId || !eStampState) return;
    setActionLoading(true);
    const stateDetail = stampStates.find(s => s.stateCode === eStampState);

    const formData = new FormData();
    formData.append("CaseId", caseId.toString());
    formData.append("FileName", eStampFile.name);
    formData.append("PdfFile", eStampFile);
    formData.append("StateCode", stateDetail?.stateCode || "");
    formData.append("EstampCode", stateDetail?.stampCode || "");

    try {
      const response = await StatusApi.eStampDocument(formData);
      if (response?.data?.success) {
        toast.success("Document successfully sent for E-Stamp!");
        setEStampModalOpen(false);
        setEStampFile(null);
        setEStampState("");
        await sendMessage(caseId, senderUserId ?? 0, `Document '${eStampFile.name}' was sent for E-Stamp.`, "system", "", "");
      } else {
        toast.error(response?.data?.message || "Failed to send document.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending for E-Stamp.");
    }
    setActionLoading(false);
  };

  if (hasAccess === null || isLoadingMessages) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: "#f8fafc",
        }}
      >
        {/* Header Skeleton */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            px: 3,
            py: 2,
            background: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(12px)",
            borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
            flexShrink: 0,
          }}
        >
          <Skeleton variant="circular" width={44} height={44} animation="wave" />
          <Box sx={{ ml: 2, flexGrow: 1 }}>
            <Skeleton variant="text" width={180} height={24} animation="wave" />
            <Skeleton variant="text" width={90} height={16} animation="wave" />
          </Box>
          <Stack direction="row" spacing={1}>
            <Skeleton variant="circular" width={32} height={32} animation="wave" />
            <Skeleton variant="circular" width={32} height={32} animation="wave" />
          </Stack>
        </Box>

        {/* Main Messages Skeleton Area */}
        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            overflow: "hidden",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            background: "linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)",
          }}
        >
          {/* Background Skeleton Bubbles */}
          <Box sx={{ width: "100%", maxWidth: "800px", display: "flex", flexDirection: "column", gap: 2, opacity: 0.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Skeleton variant="circular" width={32} height={32} animation="wave" />
              <Skeleton variant="rounded" width="45%" height={52} sx={{ borderRadius: "18px 18px 18px 4px" }} animation="wave" />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Skeleton variant="rounded" width="50%" height={60} sx={{ borderRadius: "18px 18px 4px 18px", bgcolor: "rgba(26, 35, 126, 0.1)" }} animation="wave" />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Skeleton variant="circular" width={32} height={32} animation="wave" />
              <Skeleton variant="rounded" width="38%" height={44} sx={{ borderRadius: "18px 18px 18px 4px" }} animation="wave" />
            </Box>
          </Box>

          {/* Center Floating Glassmorphic Spinner Badge */}
          <Paper
            elevation={4}
            sx={{
              position: "absolute",
              px: 4,
              py: 3,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              background: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(255, 255, 255, 0.8)",
              boxShadow: "0 12px 32px rgba(26, 35, 126, 0.12)",
            }}
          >
            <CircularProgress size={36} thickness={4.5} sx={{ color: "#1a237e" }} />
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#1a237e", letterSpacing: "0.2px" }}>
                Loading Conversation...
              </Typography>
              <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
                Fetching case messages & securing connection
              </Typography>
            </Box>
          </Paper>
        </Box>

        {/* Input Bar Skeleton */}
        <Box sx={{ p: 2, bgcolor: "#fff", borderTop: "1px solid rgba(0,0,0,0.08)", flexShrink: 0 }}>
          <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: "24px" }} animation="wave" />
        </Box>
      </Box>
    );
  }

  if (hasAccess === false) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%" sx={{ p: 4, width: '100%' }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 4, textAlign: "center", maxWidth: 400, bgcolor: "#fffbeb", border: "1px solid #f59e0b" }}>
          <ReportIcon sx={{ fontSize: 60, color: "#d97706", mb: 2 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#78350f", mb: 2 }}>
            Access Restricted
          </Typography>
          <Typography variant="body1" sx={{ color: "#92400e", mb: 3 }}>
            {accessMessage}
          </Typography>
          <Button
            variant="contained"
            color="warning"
            onClick={() => window.location.href = `/odr-workspace/${caseId}`}
            sx={{ textTransform: "none", fontWeight: 700, borderRadius: "10px", bgcolor: "#d97706", "&:hover": { bgcolor: "#b45309" } }}
          >
            Go to Dispute Workspace
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#efeae2" }}>
      {/* Modals remain at the top level */}
      <Modal open={openModal} onClose={() => setOpenMoadal(false)}>{modalBody}</Modal>
      <StatusUpdateModal
        open={openStatusModal}
        onClose={() => setOpenStatusModal(false)}
        caseStatus={caseStatus}
        onStatusUpdate={handleStatusUpdate}
        currentCaseId={selectedCase?.caseId}
      />
      <OdrStatusUpdateModal
        open={openOdrStatusModal}
        onClose={() => setOpenOdrStatusModal(false)}
        currentCaseId={selectedCase?.caseId}
        currentStatus={selectedCase?.odrStatus || selectedCase?.currentProcessingStatusName || "INITIATED"}
        onStatusUpdated={async (newStatus) => {
          if (selectedCase?.caseId && senderUserId) {
            await sendMessage(
              selectedCase.caseId,
              senderUserId,
              `ODR Case status updated to: ${newStatus}.`,
              "text",
              "",
              ""
            );
          }
          window.location.reload();
        }}
      />

      {/* VERSION 4: LIGHTWEIGHT WHITE GLASS HEADER */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        px: 3,
        py: 2,
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
        flexShrink: 0,
        zIndex: 11,
        position: "sticky",
        top: 0,
      }}>
        <Avatar
          alt={selectedCase?.orderType}
          sx={{
            width: 44,
            height: 44,
            background: "linear-gradient(135deg, #1a237e, #3949ab)",
            color: "#fff",
            fontWeight: 800,
            fontSize: "1rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
          }}
        >
          {getInitials(selectedCase?.orderType ?? "")}
        </Avatar>
        <Box sx={{ ml: 2, flexGrow: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "#1a237e", lineHeight: 1.2 }}>
            {(myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN") && (selectedCase?.orderType === "Admin Support" || selectedCase?.orderTypeId === 53)
              ? (selectedCase?.clientUserType === "CORPORATEUSER"
                ? `${selectedCase?.clientFullName || "User"} (${selectedCase?.clientOrganizationName || "N/A"})`
                : `${selectedCase?.clientFullName || "User"} - (${formatUserType(selectedCase?.clientUserType || "USER")})`)
              : (selectedCase?.orderType || "Conversation")}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.primary", opacity: 0.7, fontWeight: 600 }}>
            {selectedCase?.caseNumber ? `#${selectedCase.caseNumber}` : `ID: ${selectedCase?.caseId}`}
          </Typography>
        </Box>
        <Stack direction="row" spacing={0.5}>
          {/* Audio and Video Call for all participants */}
          {["USER", "CORPORATEUSER", "NRIUSER", "PROFESSIONAL", "ADMIN"].includes(myInfo?.userType) && !(isCompleted && !isAdmin) && (
            <>
              <Tooltip title="Audio Call">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => openCallModal(false)}><ImgPath.CallIcon /></IconButton>
              </Tooltip>
              <Tooltip title="Video Call">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => openCallModal(true)}><Videocam /></IconButton>
              </Tooltip>
            </>
          )}

          {/* Case Management Tools for Professionals & Admins */}
          {["PROFESSIONAL", "ADMIN"].includes(myInfo?.userType) && !(isCompleted && !isAdmin) && (
            <>
              <Tooltip title="Schedule Meeting">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setOpenMoadal(true)}><ImgPath.CalenderIcon /></IconButton>
              </Tooltip>
              <Tooltip title="Handle Case Status">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={handleCloseCase}><ImgPath.TaskAltRoundedIcon /></IconButton>
              </Tooltip>
              <Tooltip title="Reopen Case">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={handleReOpenCase}><ImgPath.ReplayRoundedIcon /></IconButton>
              </Tooltip>
            </>
          )}

          {/* Admin Billing Tools & Document Tools */}
          {["ADMIN", "SUPERADMIN"].includes(myInfo?.userType) && (
            <>
              <Tooltip title="Request Payment">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setPaymentModalOpen(true)}><CurrencyRupee /></IconButton>
              </Tooltip>
              <Tooltip title="E-Sign Document">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setESignModalOpen(true)}><DrawIcon /></IconButton>
              </Tooltip>
              <Tooltip title="E-Stamp Document">
                <IconButton size="small" sx={{ color: "#4a4c96ff" }} onClick={() => setEStampModalOpen(true)}><ReceiptIcon /></IconButton>
              </Tooltip>
            </>
          )}

          {/* Client SOS */}
          {["USER", "CORPORATEUSER", "NRIUSER"].includes(myInfo?.userType) && !(isCompleted && !isAdmin) && (
            <Tooltip title="Emergency SOS">
              <IconButton size="small" sx={{ color: "#4a4c96ff", backgroundColor: alpha("#fff", 0.15), "&:hover": { backgroundColor: alpha("#fff", 0.25) }, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }} onClick={handleSOSRequest}>
                <Campaign sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          )}

          {/* SuperAdmin Destructive Actions */}
          {myInfo?.userType === "SUPERADMIN" && (
            <Tooltip title="Delete Chat">
              <IconButton
                size="small"
                sx={{ color: "#d32f2f", "&:hover": { backgroundColor: "rgba(211, 47, 47, 0.08)" } }}
                onClick={handleDeleteChat}
              >
                <DeleteForeverRounded />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Box>

      {/* GLASSMORPHISM TABS FOR MEDIATION CAUCUSES */}
      {isMediation && (
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1.5,
          py: 1.5,
          px: 3,
          background: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
          flexShrink: 0,
          zIndex: 10
        }}>
          {/* Joint Tab */}
          <Button
            variant="text"
            onClick={() => setActiveTab("joint")}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              fontFamily: "Outfit",
              borderRadius: "10px",
              px: 2.5,
              py: 0.8,
              color: activeTab === "joint" ? "#1a237e" : "text.primary",
              bgcolor: activeTab === "joint" ? "rgba(26, 35, 126, 0.08)" : "transparent",
              "&:hover": {
                bgcolor: "rgba(26, 35, 126, 0.04)"
              }
            }}
          >
            Joint Session
            {tabUnreadCounts.joint > 0 && (
              <Box sx={{
                ml: 1,
                bgcolor: "#ef4444",
                color: "white",
                borderRadius: "50%",
                width: 18,
                height: 18,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                fontWeight: "bold"
              }}>
                {tabUnreadCounts.joint}
              </Box>
            )}
          </Button>

          {/* Claimant Caucus Tab */}
          {(isClaimant || isNeutral || isAdmin) && (
            <Button
              variant="text"
              onClick={() => setActiveTab("claimant_caucus")}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                fontFamily: "Outfit",
                borderRadius: "10px",
                px: 2.5,
                py: 0.8,
                color: activeTab === "claimant_caucus" ? "#4f46e5" : "text.secondary",
                bgcolor: activeTab === "claimant_caucus" ? "rgba(79, 70, 229, 0.08)" : "transparent",
                "&:hover": {
                  bgcolor: "rgba(79, 70, 229, 0.04)"
                }
              }}
            >
              {isClaimant ? "Private Caucus (with Mediator)" : "Claimant Caucus"}
              {tabUnreadCounts.claimant_caucus > 0 && (
                <Box sx={{
                  ml: 1,
                  bgcolor: "#ef4444",
                  color: "white",
                  borderRadius: "50%",
                  width: 18,
                  height: 18,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "bold"
                }}>
                  {tabUnreadCounts.claimant_caucus}
                </Box>
              )}
            </Button>
          )}

          {/* Respondent Caucus Tab */}
          {(isRespondent || isNeutral || isAdmin) && (
            <Button
              variant="text"
              onClick={() => setActiveTab("respondent_caucus")}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                fontFamily: "Outfit",
                borderRadius: "10px",
                px: 2.5,
                py: 0.8,
                color: activeTab === "respondent_caucus" ? "#0891b2" : "text.secondary",
                bgcolor: activeTab === "respondent_caucus" ? "rgba(8, 145, 178, 0.08)" : "transparent",
                "&:hover": {
                  bgcolor: "rgba(8, 145, 178, 0.04)"
                }
              }}
            >
              {isRespondent ? "Private Caucus (with Mediator)" : "Respondent Caucus"}
              {tabUnreadCounts.respondent_caucus > 0 && (
                <Box sx={{
                  ml: 1,
                  bgcolor: "#ef4444",
                  color: "white",
                  borderRadius: "50%",
                  width: 18,
                  height: 18,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "bold"
                }}>
                  {tabUnreadCounts.respondent_caucus}
                </Box>
              )}
            </Button>
          )}
        </Box>
      )}

      {/* VERSION 4: LIGHTWEIGHT AZURE MESSAGE AREA */}
      <Box
        ref={scrollRef}
        sx={{
          flex: 1,
          overflowY: "auto",
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          backgroundColor: "#f0f7ff", // Lightweight Azure
          position: "relative",
          backgroundImage: `linear-gradient(rgba(240, 247, 255, 0.95), rgba(240, 247, 255, 0.95)), url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")`,
          backgroundRepeat: "repeat",
          backgroundSize: "400px",
          backgroundAttachment: "fixed",
        }}>
        <Box sx={{ alignSelf: 'center', my: 2 }}>
          <Typography sx={{
            fontSize: '0.75rem',
            fontWeight: 700,
            color: "text.primary",
            backgroundColor: "rgba(255,255,255,0.8)",
            backdropFilter: "blur(5px)",
            px: 3,
            py: 0.75,
            borderRadius: 5,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            border: "1px solid rgba(0,0,0,0.05)",
            opacity: 0.8
          }}>
            🔒 This conversation is secured with end-to-end encryption.
          </Typography>
        </Box>

        {filteredMessages?.length > 0 ? (
          filteredMessages.map((msg, index) => {
            if (msg.messageType === "system") {
              return (
                <Box key={index} sx={{
                  alignSelf: "center",
                  my: 1,
                  maxWidth: "85%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}>
                  <Box sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.06)",
                    backdropFilter: "blur(5px)",
                    px: 2.5,
                    py: 0.75,
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    border: "1px solid rgba(0,0,0,0.05)",
                    textAlign: "center",
                  }}>
                    <Typography variant="body2" sx={{
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      color: "text.primary",
                      opacity: 0.8,
                      lineHeight: 1.4,
                    }}>
                      {msg.messageContent}
                    </Typography>
                  </Box>
                  <Typography variant="caption" sx={{ mt: 0.5, fontSize: "0.6rem", fontWeight: 700, color: "text.primary", opacity: 0.5 }}>
                    {parseISTDate(msg.timestamp).format("hh:mm A, DD-MM-YYYY")}
                  </Typography>
                </Box>
              );
            }

            const isMe = msg.senderUserId === myInfo.id;
            const isPayment = msg.messageContent?.startsWith("PAYMENT_REQUEST|");

            // Hide payment request from Professionals entirely in the UI
            if (isPayment && (myInfo?.userType === "PROFESSIONAL" || myInfo?.userType === "professional")) {
              return null;
            }

            let payAmount = "", payUrl = "", paymentId = "", paymentStatus = "", paidBy = "";
            if (isPayment) {
              const parts = msg.messageContent.split("|");
              payAmount = parts[1] || "";
              payUrl = parts[2] || "";
              paymentId = parts[3] || "";
              paymentStatus = parts[4] || "";
              paidBy = parts[5] || "";
            }

            const isPaid = paymentStatus.toUpperCase() === "PAID" || paymentStatus.toUpperCase() === "COMPLETED";

            return (
              <Box key={index} sx={{
                alignSelf: isMe ? "flex-end" : "flex-start",
                maxWidth: "75%",
                mb: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: isMe ? "flex-end" : "flex-start",
              }}>
                {/* Sender Name for incoming messages */}
                {!isMe && msg.senderUser?.userName && (
                  <Typography variant="caption" sx={{ mb: 0.5, ml: 1, fontWeight: 700, color: "#1a237e", fontSize: "0.7rem", opacity: 0.8 }}>
                    {msg.senderUser.firstName} • {formatUserType(msg.senderUser.userType)}
                  </Typography>
                )}

                <Box sx={{
                  background: isMe && !isPayment
                    ? "linear-gradient(135deg, #1a237e 0%, #283593 100%)"
                    : (isPayment ? (isPaid ? "#f0fdf4" : "#fff") : "#fff"),
                  color: (isMe && !isPayment) ? "#fff" : "text.primary",
                  px: 2, py: 1.5,
                  borderRadius: isMe ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
                  boxShadow: isMe ? "0 4px 12px rgba(26, 35, 126, 0.15)" : "0 2px 8px rgba(0,0,0,0.05)",
                  border: isPaid ? "1px solid #86efac" : (isMe ? "none" : "1px solid rgba(0,0,0,0.04)"),
                  position: "relative",
                  maxWidth: "85%",
                }}>
                  {isPayment ? (
                    <Box sx={{ minWidth: "240px" }}>
                      <Stack direction="row" alignItems="center" spacing={1} mb={1.5}>
                        <Box sx={{ p: 1, bgcolor: isPaid ? alpha("#2e7d32", 0.15) : alpha("#1a237e", 0.1), borderRadius: 1.5 }}>
                          {isPaid ? (
                            <CheckCircle sx={{ color: '#2e7d32', fontSize: 20 }} />
                          ) : (
                            <CurrencyRupee sx={{ color: '#1a237e', fontSize: 20 }} />
                          )}
                        </Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: isPaid ? "#2e7d32" : "#1a237e" }}>
                          {isPaid ? "Payment Completed" : "Payment Request"}
                        </Typography>
                      </Stack>

                      <Typography variant="body2" sx={{ mb: isPaid ? 1 : 2, color: "text.primary", fontWeight: 500 }}>
                        {isPaid ? (
                          <>
                            Payment of <b style={{ color: "#2e7d32", fontSize: '1rem' }}>₹{payAmount}</b> was successfully paid by <b style={{ color: "#1a237e" }}>{paidBy || "Client"}</b>.
                          </>
                        ) : (
                          <>
                            The professional has requested a payment of <b style={{ color: "#1a237e", fontSize: '1rem' }}>₹{payAmount}</b>
                          </>
                        )}
                      </Typography>

                      {isPaid ? (
                        <Box sx={{
                          pt: 1,
                          mt: 1,
                          borderTop: "1px solid rgba(46,125,50,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between"
                        }}>
                          <Typography variant="caption" sx={{ fontWeight: 700, color: "#2e7d32", display: "flex", alignItems: "center", gap: 0.5 }}>
                            <CheckCircle sx={{ fontSize: 16 }} /> Paid by {paidBy || "Client"}
                          </Typography>
                        </Box>
                      ) : !isMe ? (
                        <Button
                          variant="contained"
                          size="large"
                          fullWidth
                          href={payUrl}
                          target="_blank"
                          sx={{
                            background: "linear-gradient(90deg, #1a237e, #283593)",
                            color: "white",
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 700,
                            boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)"
                          }}
                        >
                          Complete Payment
                        </Button>
                      ) : (
                        <Box sx={{ pt: 1, borderTop: "1px solid rgba(0,0,0,0.05)", textAlign: 'right' }}>
                          <Typography variant="caption" sx={{ fontWeight: 700, color: "#1a237e", cursor: 'pointer' }} onClick={() => window.open(payUrl, '_blank')}>View Receipt Link →</Typography>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <>
                      {msg.messageType?.startsWith("audio") ? <AudioComponent message={msg} /> :
                        msg.messageType?.startsWith("call") ? (
                          <Box sx={{ p: 2, }}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: msg.senderUserId === myInfo.id ? "white" : "text.primary" }}>
                              {msg.isCallEnded ? `📞 Call ended. Duration: ${msg.callDuration}` : (msg.messageContent || "Incoming Call Request")}
                            </Typography>
                            {!msg.isCallEnded ? (
                              (agoraCallData.open && Number(agoraCallData.messageId) === Number(msg.pkChatMessage)) ? (
                                <Typography variant="caption" sx={{ color: msg.senderUserId === myInfo.id ? "rgba(255,255,255,0.9)" : "#10b981", fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                  <span style={{ animation: 'pulse 1.5s infinite' }}>●</span> Call in Progress
                                </Typography>
                              ) : (
                              <Stack direction="row" spacing={1} mt={1}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  startIcon={msg.messageContent?.includes("Video") || msg.messageContent?.includes("📹") ? <Videocam /> : <Call />}
                                  onClick={() => handleCallConnection(true, msg.messageContent?.includes("Video") || msg.messageContent?.includes("📹") || false)}
                                  sx={{
                                    borderRadius: 20,
                                    backgroundColor: msg.senderUserId === myInfo.id ? "#fff" : "primary.main",
                                    color: msg.senderUserId === myInfo.id ? "primary.main" : "#fff",
                                    "&:hover": { backgroundColor: msg.senderUserId === myInfo.id ? "#eee" : "primary.dark" }
                                  }}
                                >
                                  Join Call
                                </Button>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  color="error"
                                  onClick={() => handleDeclineCall(msg.pkChatMessage?.toString() || "", msg.senderUserId === myInfo.id)}
                                  sx={{
                                    borderRadius: 20,
                                    backgroundColor: "rgba(255,255,255,0.9)",
                                    "&:hover": { backgroundColor: "#fff" }
                                  }}
                                >
                                  {msg.senderUserId === myInfo.id ? "Cancel Call" : "Decline"}
                                </Button>
                              </Stack>
                              )
                            ) : (
                              <Typography variant="caption" sx={{ color: msg.senderUserId === myInfo.id ? "rgba(255,255,255,0.7)" : "text.secondary" }}>Session Closed</Typography>
                            )}
                          </Box>
                        ) :
                          msg.messageType?.startsWith("file") ? <AttachmentComponent message={msg} downloadImage={downloadImage} setSelectedDocument={({ attachmentUrl, docType }) =>
                            setSelectedDocument({
                              url: attachmentUrl,
                              docType: docType,
                            })} /> :
                            <Typography
                              variant="body2"
                              sx={{
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                                color: msg.senderUserId === myInfo.id ? "white" : "black",
                                whiteSpace: "pre-wrap",
                                fontWeight: 500,
                                lineHeight: 1.5,
                              }}
                            >
                              {msg.messageContent}
                            </Typography>
                      }
                    </>
                  )}
                </Box>
                <Typography variant="caption" sx={{ mt: 0.5, px: 1, fontSize: "0.65rem", fontWeight: 700, color: "text.primary", opacity: 0.6 }}>
                  {parseISTDate(msg.timestamp).format("hh:mm A, DD-MM-YYYY")}
                </Typography>
              </Box>
            );
          })
        ) : <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><NoData cstmMsg="Your conversation will appear here." /></Box>}

        {/* Spacer for Mobile Fixed Input */}
        <Box sx={{ height: { xs: "90px", md: "10px" }, flexShrink: 0 }} />
      </Box>

      {/* RECORDING PREVIEW */}
      {isRecording && (
        <Box sx={{ p: 1, backgroundColor: "#fff", borderTop: "1px solid #ccc" }}>
          <canvas ref={canvasRef} width={300} height={40} style={{ margin: "0 auto", display: "block" }} />
        </Box>
      )}

      {recordedAudioUrl && (
        <Box sx={{ display: "flex", alignItems: "center", p: 1, backgroundColor: "#fff", borderTop: "1px solid #ccc" }}>
          <audio controls src={recordedAudioUrl} style={{ height: 30, flex: 1 }} />
          <IconButton onClick={handleDeleteRecording} color="error"><DeleteForeverRounded /></IconButton>
        </Box>
      )}

      {/* ODR Professional Case Status Update Bar */}
      {isNeutral && isOdrCase && (
        <Box sx={{
          px: 3,
          pt: 1.5,
          pb: 0.5,
          backgroundColor: "rgba(240, 247, 255, 0.9)",
          backdropFilter: "blur(10px)",
          borderTop: "1px solid rgba(40, 49, 101, 0.1)",
          position: { xs: "fixed", md: "relative" },
          bottom: { xs: 72, md: "auto" }, left: 0, right: 0, zIndex: 11,
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            p: 0.75,
            backgroundColor: "rgba(40, 49, 101, 0.04)",
            borderRadius: "16px",
            border: "1px dashed rgba(40, 49, 101, 0.25)",
          }}>
            <Box sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: "#10b981",
              flexShrink: 0,
              boxShadow: "0 0 0 3px rgba(16,185,129,0.2)"
            }} />
            <InputBase
              value={odrStatusInput}
              onChange={(e) => setOdrStatusInput(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleOdrProfessionalStatusUpdate(); } }}
              placeholder="Post a custom ODR case status (visible everywhere)..."
              sx={{
                flex: 1,
                fontSize: "13px",
                fontWeight: 500,
                color: "#283165",
                fontFamily: "Inter",
                "& input::placeholder": { color: "#94a3b8" }
              }}
            />
            <Button
              size="small"
              variant="contained"
              disabled={!odrStatusInput.trim() || odrStatusSubmitting}
              onClick={handleOdrProfessionalStatusUpdate}
              sx={{
                bgcolor: "#283165",
                color: "#fff",
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "12px",
                px: 2,
                py: 0.5,
                flexShrink: 0,
                "&:hover": { bgcolor: "#1c234b" },
                "&:disabled": { bgcolor: "#e2e8f0", color: "#94a3b8" }
              }}
            >
              {odrStatusSubmitting ? "Updating..." : "Update Status"}
            </Button>
          </Box>
        </Box>
      )}

      {/* VERSION 4: CLEAN WHITE PILL INPUT ISLAND */}
      <Box sx={{
        px: 3,
        py: 2,
        backgroundColor: "rgba(240, 247, 255, 0.8)", // Lightweight Azure tint
        backdropFilter: "blur(10px)",
        borderTop: "1px solid rgba(0,0,0,0.04)",
        position: { xs: "fixed", md: "relative" },
        bottom: 0, left: 0, right: 0, zIndex: 12,
        pb: "env(safe-area-inset-bottom, 20px)"
      }}>
        <Paper elevation={0} sx={{
          display: "flex",
          alignItems: "flex-end",
          p: 0.75,
          backgroundColor: "#fff",
          borderRadius: "24px",
          border: "1px solid rgba(26, 35, 126, 0.15)",
          transition: "all 0.3s ease",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
          "&:focus-within": {
            boxShadow: "0 8px 25px rgba(26, 35, 126, 0.12)",
            borderColor: "#1a237e",
          }
        }}>
          {isCompleted && !isAdmin ? (
            <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Typography variant="body2" sx={{ color: "error.main", fontWeight: 500 }}>
                This case has been completed. The chat is closed for new messages.
              </Typography>
            </Box>
          ) : (
            <>
              <IconButton
                component="label"
                sx={{
                  color: "#1a237e",
                  "&:hover": { backgroundColor: alpha("#1a237e", 0.05) }
                }}
              >
                <AttachFile />
                <input
                  type="file"
                  multiple
                  hidden
                  accept=".jpg,.jpeg,.png,.gif,.heic,.heif,.webp,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.mp4,.webm,.mov,.mp3,.wav,.m4a"
                  onChange={handleAttachmentUpload}
                />
              </IconButton>

              <InputBase
                value={input}
                multiline
                maxRows={6}
                sx={{
                  ml: 1,
                  flex: 1,
                  fontSize: "15px",
                  fontWeight: 500,
                  py: 1,
                }}
                placeholder="Type your message..."
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => handleEnterPress(e)}
              />

              <Stack direction="row" spacing={0.5} sx={{ mr: 0.5, mb: 0.2 }}>
                <IconButton
                  onClick={isRecording ? handleStopRecording : handleStartRecording}
                  sx={{
                    color: isRecording ? "#ff1744" : "#1a237e",
                    backgroundColor: isRecording ? alpha("#ff1744", 0.1) : "transparent",
                    "&:hover": { backgroundColor: isRecording ? alpha("#ff1744", 0.2) : alpha("#1a237e", 0.05) }
                  }}
                >
                  <Mic />
                </IconButton>

                <IconButton
                  onClick={handleSend}
                  disabled={!input.trim() && !recordedAudioUrl}
                  sx={{
                    backgroundColor: "#1a237e",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#283593" },
                    "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" },
                    width: 40,
                    height: 40,
                    boxShadow: input.trim() ? "0 4px 12px rgba(26, 35, 126, 0.3)" : "none"
                  }}
                >
                  <Send sx={{ fontSize: 20, ml: 0.5 }} />
                </IconButton>
              </Stack>
            </>
          )}
        </Paper>
      </Box>

      {/* Fullscreen Previews & Payment Dialog (Keep existing logic) */}
      {/* Payment Modal */}
      <Dialog open={paymentModalOpen} onClose={() => {
        setPaymentModalOpen(false);
        setBaseAmount("");
        setAmount("");
      }}>
        <DialogTitle>Send Payment Link</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Enter the base amount. The system will automatically add <strong>18% GST</strong> to calculate the total.
          </Typography>

          <TextField
            autoFocus
            margin="dense"
            label="Base Amount"
            type="number"
            fullWidth
            variant="outlined"
            value={baseAmount}
            onChange={(e) => {
              const val = e.target.value;
              setBaseAmount(val);
              if (val && !isNaN(Number(val))) {
                const total = (Number(val) * 1.18).toFixed(2);
                setAmount(total);
              } else {
                setAmount("");
              }
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />

          {baseAmount && !isNaN(Number(baseAmount)) && (
            <Box sx={{ mt: 2, p: 2, bgcolor: "#f8f9fa", borderRadius: 1, border: "1px dashed #ccc" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body2">Base Amount:</Typography>
                <Typography variant="body2" fontWeight="500">₹{Number(baseAmount).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body2">GST (18%):</Typography>
                <Typography variant="body2" fontWeight="500">₹{(Number(baseAmount) * 0.18).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, pt: 1, borderTop: "1px solid #ddd" }}>
                <Typography variant="subtitle2" fontWeight="bold">Total Amount:</Typography>
                <Typography variant="subtitle2" fontWeight="bold" color="primary.main">₹{amount}</Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPaymentModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleSendPaymentLink}
            variant="contained"
            disabled={isGeneratingLink || !amount}
          >
            {isGeneratingLink ? "Generating..." : "Send Link"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* E-Sign Modal */}
      <Dialog open={eSignModalOpen} onClose={() => setESignModalOpen(false)}>
        <DialogTitle>Send Document for E-Sign</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Upload a PDF document to send to all parties for E-Signature.
          </Typography>
          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={{ p: 2, borderStyle: "dashed", borderRadius: 2 }}
          >
            {eSignFile ? eSignFile.name : "Upload PDF Document"}
            <input type="file" hidden accept=".pdf" onChange={(e) => setESignFile(e.target.files?.[0] || null)} />
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setESignModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleSendForESign}
            variant="contained"
            disabled={actionLoading || !eSignFile}
          >
            {actionLoading ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* E-Stamp Modal */}
      <Dialog open={eStampModalOpen} onClose={() => setEStampModalOpen(false)}>
        <DialogTitle>Send Document for E-Stamp & E-Sign</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Select a state and upload a PDF document.
          </Typography>
          <FormControl fullWidth sx={{ mb: 3, mt: 1 }}>
            <InputLabel>Select State</InputLabel>
            <Select
              value={eStampState}
              label="Select State"
              onChange={(e) => setEStampState(e.target.value)}
            >
              {(Array.isArray(stampStates) ? stampStates : []).map((s) => (
                <MenuItem key={s.pkEStampDetails} value={s.stateCode}>
                  {s.stateName} - ₹{s.denomination}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={{ p: 2, borderStyle: "dashed", borderRadius: 2 }}
          >
            {eStampFile ? eStampFile.name : "Upload PDF Document"}
            <input type="file" hidden accept=".pdf" onChange={(e) => setEStampFile(e.target.files?.[0] || null)} />
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEStampModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleSendForEStamp}
            variant="contained"
            disabled={actionLoading || !eStampFile || !eStampState}
          >
            {actionLoading ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>
      {agoraCallData.open && (
        <AgoraCall
          appId={agoraCallData.appId}
          channelName={agoraCallData.channelName}
          token={agoraCallData.token}
          uid={agoraCallData.uid}
          participants={agoraCallData.participants}
          onClose={() => setAgoraCallData({ ...agoraCallData, open: false })}
          onEndCall={handleEndCall}
          isVideoCall={agoraCallData.isVideoCall}
        />
      )}

      {/* Call Participant Selection Modal */}
      <Dialog open={callModalOpen} onClose={() => setCallModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ bgcolor: "#1a237e", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6">{callIsVideo ? "📹 Initiate Video Call" : "📞 Initiate Voice Call"}</Typography>
          <IconButton size="small" onClick={() => setCallModalOpen(false)} sx={{ color: "#fff" }}><Close /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#334155" }}>
            Call Options:
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={isGroupCall}
                onChange={(e: any) => {
                  setIsGroupCall(e.target.checked);
                  if (e.target.checked) setSelectedCallUserIds([]);
                }}
              />
            }
            label={<strong>🌐 Group Call (Ring All Members)</strong>}
          />
          {!isGroupCall && (
            <Box mt={2}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, display: "block", mb: 1 }}>
                Select Specific Member(s) to Call:
              </Typography>
              {(() => {
                const participants = getCallParticipantsList();
                if (participants.length === 0) {
                  return (
                    <Typography variant="body2" color="textSecondary" sx={{ fontStyle: "italic", py: 1 }}>
                      No other members found in this chat.
                    </Typography>
                  );
                }
                return (
                  <Stack spacing={1}>
                    {participants.map(([uId, uName]) => (
                      <FormControlLabel
                        key={uId}
                        control={
                          <Checkbox
                            checked={selectedCallUserIds.includes(Number(uId))}
                            onChange={(e: any) => {
                              const numId = Number(uId);
                              if (e.target.checked) {
                                setSelectedCallUserIds((prev) => [...prev, numId]);
                              } else {
                                setSelectedCallUserIds((prev) => prev.filter((id) => id !== numId));
                              }
                            }}
                          />
                        }
                        label={String(uName)}
                      />
                    ))}
                  </Stack>
                );
              })()}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setCallModalOpen(false)} variant="outlined">Cancel</Button>
          <Button
            onClick={handleStartSelectedCall}
            variant="contained"
            color="primary"
            disabled={!isGroupCall && selectedCallUserIds.length === 0}
          >
            Start Call
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SingleChatScreen1;
const sxHead = {
  backgroundColor: "primary.main",
  px: 2,
  "& >p:first-of-type": {
    color: "white",
  },
  "& >button": {
    color: "white",
  },
};
const sxMain = {
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  transform: `translate(-${50}%, -${50}%)`,
  position: "absolute",
  outline: "none",
  // overflow: "auto",
  borderRadius: 1.25,
};
